import classNames from 'classnames';

import { FaqCard } from '@/blocks/sections/Questions/components/FaqCard';

import styles from './styles.module.scss';

export function FaqBlock(props: { questionsData: { question: React.ReactNode; answer: React.ReactNode }[] }) {
  return (
    <div className={classNames(styles.layoutCards)}>
      {props.questionsData.map((card, index) => (
        <FaqCard key={index} index={index} cardData={card} />
      ))}
    </div>
  );
}
